import type { CategoryKey } from './Concepts';
import configuration from './configuration.json';

/*
 * This file defines only the default values of the configuration.
 * The actual configuration is managed in a store, where the default values can be overwritten.
 */

export interface Configuration {
	// #region Sounds
	readonly backgroundSoundEnabled: boolean;
	readonly backgroundSoundVolume: number;
	readonly backgroundSoundVolumeBaseModifier: number;
	readonly soundEffectsEnabled: boolean;
	readonly soundEffectsVolume: number;
	// #endregion
	// #region Playthrough
	readonly defaultPlayerName: string;
	readonly resetPlaythroughAfterIntro: boolean;
	readonly roundCountPerPlaythrough: number;
	readonly initialPersonaCountPerPlaythrough: number;
	readonly randomInitialPersonas: boolean;
	readonly additionalPersonaCountPerRound: number;
	readonly randomAdditionalPersonas: boolean;
	// #endregion
	// #region Highscore
	readonly globalHighscoreEnabled: boolean;
	readonly maxHighscoreEntryCount: number;
	readonly backendUrl: string;
	// #endregion
	// #region Rating
	readonly surveyUrl?: string;
	// #endregion
	defaultCategory: CategoryKey;
}

const configurationData: Configuration = configuration;

export default configurationData;
